import React, { useReducer } from 'react';

const FEATURES = {
  QUICK_LINKS: 'nitrogen-ui/quick-links',
  MAGENTO_CARDS: 'nitrogen-ui/magento-cards',
  EXTERNAL_WEBSITE_CONFIGURATION: 'nitrogen-ui/external-website-configuration',
  DATA_IMPORT_WIZARD: 'nitrogen-ui/data-import-wizard',
  DOCS: 'nitrogen-ui/docs',
  JO_CONFIGURATION: 'nitrogen-ui/jo-configuration',
  THIRD_PARTY_PRODUCTS: 'nitrogen-ui/third-party-products',
  ODE_CONFIGURATION: 'nitrogen-ui/ode-configuration',
  PROFILE_GENERATION: 'nitrogen-ui/profile-generation',
  EVENT_GENERATION: 'nitrogen-ui/event-generation',
  PROFILE_GENERATION_GLOBAL_SCHEMAS:
    'nitrogen-ui/profile-generation-global-schemas',
  TOOLS_SCREEN: 'nitrogen-ui/tools-screen',
  SOURCES_CONFIGURATION: 'nitrogen-ui/sources-configuration',
  QS_DATA_IMPORT: 'nitrogen-ui/qs-data-import',
  QUICK_SETUP_INITIAL_VALIDATION: 'quick-setup/initial-validation'
};

const FeaturesContext = React.createContext();

export const initialState = {
  enabledFeatures: []
};

const isFeatureEnabled = (featureName) => {
  return initialState.enabledFeatures.find(
    (feature) => feature.name === featureName
  );
};

const handlers = {};

const reducerFactory =
  (initialState, handlers) =>
  (state = initialState, action) =>
    handlers && handlers[action.type]
      ? handlers[action.type](state, action)
      : state;

const reducer = reducerFactory(initialState, handlers);

// Provider component which will be used to wrap a group of components in order to pass context variables
const FeaturesContextProvider = (props) => {
  const [state] = useReducer(reducer, initialState);
  const value = { state, isFeatureEnabled, ...FEATURES };

  return (
    <FeaturesContext.Provider value={value}>
      {props.children}
    </FeaturesContext.Provider>
  );
};

export { FeaturesContext, FeaturesContextProvider };
